import React,{Component} from "react";
//import "../../node_modules/react-pro-sidebar/dist/css/styles.css";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Moment from "moment";
import ModalLogin from './ModalLogin';
import Mymodal from './modal';
import Cookies from "universal-cookie";
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
export default class Attendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        islocation:true,
        isLoaded: true,
        input:{},
        myitems: [],
        statustext:[],
        ErrMsg:"", //<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        cMonth:new Date().getMonth(),
        cYear:new Date().getFullYear(),
        cValue:new Date().getFullYear()+'-'+new Date().getMonth(),
        DivClass: "ErrDiv",
        minDate:'',
        maxDate:'',
        leaveclass: "tdm"
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLoadData=this.handleLoadData.bind(this);
    }
    cur=(num)=> {
        if(num > 0)
            return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    handleChange=(e)=>{
        let cString=e.target.value;
        this.setState({cMonth:cString.substring(cString.length-2),cValue:e.target.value,cYear:cString.substring(0,4)});
    }
    handleSubmit=(e)=>{
    }
    handleLoadData(){
        document.body.style.cursor="wait";
        let input=this.state.input;
        let loginid=cookies.get("LoginID");

        this.setState({input,isLoaded:true,ErrMsg:<img src={logo} alt="Not found"/>,myitems:[],divxls:"none"});
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_attendance/'+loginid+"/"+this.state.cMonth+"/"+this.state.cYear, // +this.state.month,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                console.log(response.data);
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                islocation:true,
                ErrMsg:"",
                divxls:'block',
                myitems: response.data
                });
            })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
        })  
    }

    componentDidMount(){
        let ccdate=new Date();
        if(cookies.get("LoginID"))
        {  
            let cmonth=this.state.cMonth;
            let cyear=this.state.cYear;
            if(cmonth >= 7 && cmonth <= 12)
                this.setState({minDate:cyear +"-07",maxDate: (cyear+1)+"-06"});
            else
                this.setState({minDate:(cyear-1) +"-07",maxDate: cyear+"-06"});
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }
    
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;    
        if (!isLoaded ) 
        {
            return(
            <div className="container1">
              <div className="center">
                {this.state.ErrMsg}
              </div>
          </div>
            );
        } 
        else 
        {
            return(
            <div className="container1">
            <div width="95%" align="left">
                <br></br>
            <div className="inner-profile33" >
            <span className="box-title">Attendance</span>
            <div className="inner-profile2" >

            <label>Select Date: </label>
            <input type="month" id="start" name="start"  onChange={this.handleChange} value={this.state.cValue} />
            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={this.handleLoadData}>Submit </button>
            </div>
            <br></br>
            <table style={{width:"100%",paddingLeft:"0%",paddingTop:"10px"}}>
            <thead>
                <tr className="tr">
                    <th className="th" scope="col">Date</th>
                    <th className="th" scope="col">Day</th>
                    <th className="th" scope="col">Time in</th>
                    <th className="th" scope="col">Time out</th>
                    <th className="th" scope="col">Holiday / Off</th>
                    <th className="th" scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
            {
                items.map((result ,i) => {
                    let leavedays='';
                    let attclass="tdm";
                    if(result.leaveday == 0.5 )
                    {
                        leavedays='half day '+result.leavetype;
                        attclass="tdmleaves";
                    }
                    else if (result.leaveday == 1 )
                    {
                        leavedays='1.0 day '+ result.leavetype;
                        attclass="tdmleaves";
                    }
                    if(result.timein==null && result.timeout==null && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date() )
                    {
                        leavedays='Absent  ';
                        attclass="tdmabsent";
                    }
                    
/*                    if(result.timein > "10:30:00"  && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date() )
                    {
                        leavedays='Absent 1st half ';
                        attclass="tdmabsent";
                    }
                    if(result.timeout < "15:30:00"  && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date() )
                    {
                        leavedays='Absent 2nd half ';
                        attclass="tdmabsent";
                    }
 */                               
                    if(result.dayname == "Sunday")
                    {
                        attclass="tdmsunday";
                    }
                    if(result.holidays.length > 1)
                    {
                        attclass="tdmholiday";
                    }
                    if(result.leavetype == "VA")
                    {
                        attclass="tdm";
                    }
                    return(
                        <tr className="trc" key={i}>
                            <td className={attclass}>{Moment(result.cdate).format("DD/MM/YYYY")}</td>
                            <td className={attclass}>{result.dayname}</td>
                            <td className={attclass}>{result.timein}</td>
                            <td className={attclass}>{result.timeout}</td>
                            <td className={attclass}>{result.holidays}</td>
                            <td className={attclass}>{leavedays}</td>
                        </tr>
                    )
                        
                })}

            </tbody>
        </table>
        </div>
        <div style={{textAlign:"center", width:"88%"}} >       {this.state.ErrMsg}</div>

        </div>
        </div>
        );
    }
}}
